import { render } from "./GridDashboard.vue?vue&type=template&id=10084f62"
import script from "./GridDashboard.vue?vue&type=script&lang=js"
export * from "./GridDashboard.vue?vue&type=script&lang=js"

import "./GridDashboard.vue?vue&type=style&index=0&id=10084f62&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__